export enum OrderStatus {
  Pending = 0,
  Processing = 1,
  Ready = 2,
  Cancelled = 3,
  Paid = 4,
  Refunded = 5,
}
